import React, { useState } from 'react';
import { Smartphone } from 'lucide-react';
import { MobilePromoSlides } from './MobilePromoSlides';
export function MobilePromoButton() {
  const [isOpen, setIsOpen] = useState(false);
  return <>
      {/* Floating button - only visible on mobile */}
      <button onClick={() => setIsOpen(true)} className="md:hidden fixed bottom-6 right-6 z-40 bg-[#d4a574] hover:bg-[#c29463] text-[#1e3a5f] p-4 rounded-full shadow-2xl transition-all hover:scale-110 animate-pulse" aria-label="Ver oferta especial" data-id="element-585">
        <Smartphone className="w-6 h-6" data-id="element-586" />
      </button>

      {/* Mobile promo slides modal */}
      {isOpen && <MobilePromoSlides onClose={() => setIsOpen(false)} data-id="element-587" />}
    </>;
}